// extracted by mini-css-extract-plugin
module.exports = {"mi85h81":"mi85h81","c1kiracd":"c1kiracd"};